/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostAnomalyByCloud {
    getFixupPrototypeFunction() { return CostAnomalyByCloud.fixupPrototype; }

    static newInstance(model: Partial<CostAnomalyByCloud>): CostAnomalyByCloud {
        let obj = Object.assign(new CostAnomalyByCloud(), model);
        CostAnomalyByCloud.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostAnomalyByCloud>): CostAnomalyByCloud {
        if (!model) return null;
        return CostAnomalyByCloud.newInstance(<CostAnomalyByCloud> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostAnomalyByCloud) {
        if (!obj) return;

        models.CostAnomalyByCloud.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostAnomalyByCloud): boolean {
        Object.setPrototypeOf(obj, CostAnomalyByCloud.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.cost_anomaly === undefined) {
            this.cost_anomaly = 0;
        }
        if (typeof this.date === "string") {
            this.date = new Date(<string><any>this.date);
        }
    }

    cloud: string;

    date: Date;

    cost_anomaly: number;

}
